export const colors = Object.freeze({
  blue: {
    500: 'rgba(67, 138, 237, 1)',
    50: 'rgba(67, 138, 237, 0.07)'
  },
  green: {
    500: 'rgba(106, 196, 11, 1)',
    50: 'rgba(106, 196, 11, 0.07)'
  },
  lightGreen: {
    500: 'rgba(201, 211, 79, 1)',
    50: 'rgba(201, 211, 79, 0.07)'
  },
  yellow: {
    500: 'rgb(244, 211, 36, 1)',
    50: 'rgb(244, 211, 36, 0.07)'
  },
  orange: {
    500: 'rgba(255, 102, 0, 1)',
    50: 'rgba(255, 102, 0, 0.07)'
  },
  red: {
    500: 'rgba(240, 68, 56, 1)',
    50: 'rgba(240, 68, 56, 0.07)'
  }
})
